import { Link } from "react-router-dom";
import type { Special } from "@/types/news";

interface SpecialPicksProps {
  items: Special[];
}

export default function SpecialPicks({ items }: SpecialPicksProps) {
  if (items.length === 0) return null;
  const [first, ...rest] = items;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <Link
        to={`/special/${first.id}`}
        className="group relative lg:col-span-2 h-64 md:h-80 rounded-lg overflow-hidden cursor-pointer"
      >
        <img
          src={first.cover}
          alt={first.title}
          title={`${first.title} - 吃瓜爆料`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
        <div className="absolute bottom-0 left-0 p-5 md:p-6">
          <span className="inline-flex items-center gap-1 h-6 px-2.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-3">
            <i className="ri-book-2-line" /> 精选专题
          </span>
          <h3 className="text-lg md:text-2xl font-bold text-background-50 leading-snug line-clamp-2">{first.title}</h3>
          <p className="hidden sm:block text-sm text-background-100/90 mt-2 leading-relaxed line-clamp-2 max-w-2xl">
            {first.intro}
          </p>
        </div>
      </Link>

      <div className="flex flex-col gap-4">
        {rest.slice(0, 2).map((item) => (
          <Link
            key={item.id}
            to={`/special/${item.id}`}
            className="group flex-1 min-h-[120px] rounded-lg overflow-hidden relative cursor-pointer"
          >
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 吃瓜爆料`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 p-4">
              <h3 className="text-sm md:text-base font-bold text-background-50 leading-snug line-clamp-2">
                {item.title}
              </h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}